
const Loader = () => {
  return (
    <div className="spinner-border text-primary loader">
      <span className="sr-only">Loading..</span>
    </div>
  );
};

export default Loader;
